import React from 'react';

import styles from './RobotLoader.module.scss';
import { ReactComponent as Robot } from 'assets/profile/happy_robot.svg';

const RobotLoader = (): React.ReactElement => {
  return (
    <div className={styles.container}>
      <div className={styles.text}>
        <strong>UnifAi</strong> is getting your results!
      </div>
      <div className={styles.image}>
        <Robot />
      </div>
    </div>
  );
};

export default RobotLoader;
